<template>
  <section id="main">
    <h1 class="fs-21 w-bold darks mb-4">Información básica</h1>

    <article
      v-if="statusMessage"
      class="c-card-alert p-3 mb-4"
      :class="`c-card-alert--${statusMessage.type}`"
    >
      {{statusMessage.text}}
    </article>

    <EditForm
      ref="editFormProfile"
      variant="full"
      :isUpdating.sync="isUpdating"
      :isChanged.sync="isChanged"
      :handleSuccess="handleSuccess"
      :handleError="handleError"
      :handleInvalid="handleInvalid"
    >
      <template v-slot:actions>
        <div class="d-flex justify-content-end align-items-center">
          <router-link to="/" class="c-link c-link--black small">
            Volver al panel
          </router-link>
          <button
            @click="$refs.editFormProfile.updateProfile()"
            class="c-button c-button--primary small ms-3"
            :class="{loading : isUpdating}"
            :disabled="isUpdating || !isChanged"
          >
            {{
              (isUpdating) ? 'Actualizando...' : 'Guardar cambios'
            }}
            <img
              class="c-button__spinner"
              src="@/assets/images/animations/spinner-white.png"
              alt="loading"
            />
          </button>
        </div>
      </template>
    </EditForm>
  </section>
</template>

<script>
import { scroller } from 'vue-scrollto/src/scrollTo';

export default {
  data() {
    return {
      scroll: scroller(),

      isUpdating: false,
      isChanged: false,

      statusMessage: null,
    };
  },
  components: {
    EditForm: () => import(/* webpackChunkName: "edit-form" */'@/components/profile/EditForm.vue'),
  },
  methods: {
    handleSuccess() {
      this.scroll('#app');

      this.statusMessage = {
        text: 'Datos actualizados exitosamente.',
        type: 'success',
      };

      setTimeout(() => {
        this.statusMessage = null;
      }, 5000);
    },
    handleError() {
      this.scroll('#app');

      this.statusMessage = {
        text: 'Error al guardar sus datos, revise si todos estan correctos o intentelo más tarde.',
        type: 'error',
      };

      setTimeout(() => {
        this.statusMessage = null;
      }, 5000);
    },
    handleInvalid() {
      this.scroll('#app');
    },
  },
};
</script>
